import { createFileRoute, redirect } from '@tanstack/react-router';

/* Old links and bookmarks, in chat history or a browser, still reach the Team page. */
export const Route = createFileRoute('/_app/contacts')({
  beforeLoad: () => {
    throw redirect({ to: '/team', replace: true });
  },
});
